/**
 * Project.
 *
 * @todo @export
 *
 * @interface Project
 */
interface Project {

  /** Project id. */
  _id: string;

  /** Current state. */
  active: boolean;

  /** Project location address line, containing street + number. */
  address: string;

  /** Collection of all child modules, with id and name properties. */
  allModules: {
    _id: ProjectModule['_id'];
    displayName: ProjectModule['name'];
  }[];

  /** Collection of all child submodules, with id and name properties. */
  allSubmodules: {
    _id: ProjectSubmodule['_id'];
    displayName: ProjectSubmodule['name'];
  }[];

  /** Whether the project is archived. */
  archived: boolean;

  /** Available versions. */
  availableVersions: {
    _id: Project['_id'];
    versionName: string;
  }[];

  /** Collection of all child basic areas. */
  basicAreas: BasicArea[];

  /** Collection of all child buildings. */
  buildings: Building[];

  /** Project location's city. */
  city: string;

  /** NAme of client. */
  clientName: string;

  /** Comments. */
  comments: any[];

  /** Project location's country. */
  country: string;

  /** Creation date as ISO string. */
  createdAt: string;

  /** Collection of downloadable documents within the project. */
  downloadableDocuments: Document[];

  /** User db id. */
  dsUserDb: string;

  /** Project key. */
  key: string;

  /** Project language. */
  language: 'en' | 'nl';

  /** Project location's latitude. */
  lat: number | null;

  /** Project location's longitude. */
  lng: number | null;

  /** Collection of child modules as whole module entities. */
  modules: ProjectModule[];

  /** Project name. */
  name: string;

  /** Project number. */
  number: string;

  /** Project quality level. */
  qualityLevel: string;

  /** Start situation. */
  startSituation: string;

  /** Template id. */
  templateId: string;

  /** Last updated date as ISO string. */
  updated: string;

  /** Uploads. */
  uploads: any;

  /** Users assigned to project. */
  users: User[];

  /** Version id. */
  versionId: string;

  /** Version name. */
  versionName: string;

  /** Available versions. */
  versions: any[];

  /** Project location's zip code. */
  zipcode: string;

  __v: number;
  _elementCounter: number;
};
